var _radialGradient, _path, _linearGradient, _path2, _linearGradient2, _path3, _linearGradient3, _path4, _path5, _path6, _path7, _radialGradient2, _path8, _path9, _path10, _radialGradient3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _g2, _linearGradient4, _path25, _radialGradient4, _path26, _radialGradient5, _path27, _radialGradient6, _path28, _path29, _radialGradient7, _path30, _radialGradient8, _path31, _radialGradient9, _path32, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenieSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8896",
    cx: 31.846,
    cy: 116.717,
    r: 62.338,
    gradientTransform: "matrix(0 -1 1.0982 0 -96.336 148.563)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#29b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945,
    stopColor: "#0277bd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.17 87.23c-1.61 1.17-13.65 3.19-6.15-1.04c4.93-2.78 7.47-12.01-3.68-14.8C89.93 68.56 77.74 88.46 76 92.63c-4.13 9.89-9.85 18.2-21.58 24.17c-10.49 5.35-20.28 5.85-32.53-.08c-9.98-4.83-13.16-13.96-11.79-25.88a68.795 68.795 0 0 1 .98-6.23c1.39-6.75 2.75-7.67.64-16.95l18.23-2.03l3.12-.35l25.61-2.86c0 6.72-.77 11.82-10.54 21.28c-3.88 3.76-10.54 6.96-11.9 11.89c-.45 1.65-.75 3.41.72 5.6c1.68 2.52 13.54 8.51 24.79-7.46c1.15-1.63 7.52-11.3 9.25-13.91c4.26-6.43 8.9-12.1 16-15.64c25-12.48 36.92 13.78 24.17 23.05z",
    fill: "url(#IconifyId17ecdb2904d178eab8896)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab8897",
    gradientUnits: "userSpaceOnUse",
    x1: 47.887,
    y1: 46.087,
    x2: 22.549,
    y2: 18.384,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005584",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#005584"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.79 79.63c-3.48 3.22-7.56 5.71-11.37 8.54s-7.45 6.11-9.57 10.35s-2.46 9.63.15 13.59c1.16 1.76 4.5 5.43 13.12 7.74c0 0-13.46-6.56-5.76-17.6c2.44-3.5 12.48-9.35 15.72-12.12s2.52-1.64 5.48-4.71c3.37-3.49 7.68-8.67 9.43-13.19c1.23-3.18 2.97-8.37-2.41-8.37S40.87 76.79 37.79 79.63z",
    fill: "url(#IconifyId17ecdb2904d178eab8897)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab8898",
    gradientUnits: "userSpaceOnUse",
    x1: 88.486,
    y1: 39.373,
    x2: 116.42,
    y2: 39.373,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd54f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#fec846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#faa630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#f37f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6d23"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.05 103.88c-.61-.2-1.31-.42-1.49-.78c-2.36-4.79-.74-10.09 3.95-12.9c1.65-.98 4.67-1.87 6.88-2.51c.53-.15 1.02-.3 1.45-.43c6.59-2.02 10.95-5.1 12.95-9.16c.94-1.91 1.14-3.36 1.13-4.78c.25 1.08.5 2.27.5 4.46c0 6.35-3.71 9.17-7.73 11.26c-2.2 1.15-4.47 1.58-6.87 2.03c-2.35.45-4.79.91-7.11 2.11c-2.33 1.21-3.8 2.77-4.35 4.66c-.52 1.76-.24 3.8.82 6.09c-.05-.02-.09-.03-.13-.05z",
    fill: "url(#IconifyId17ecdb2904d178eab8898)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab8899",
    gradientUnits: "userSpaceOnUse",
    x1: 78.618,
    y1: 57.189,
    x2: 63.823,
    y2: 19.808,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f37f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6d23"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.23 119.06c3.15-3.02 10.55-10.57 13.37-18.86c6.64-19.59 9.45-22.73 13.71-27.5l.07-.08c4.77-5.57 10.3-9.01 16.02-10.62c-5.02 3.77-8.31 10.41-11.19 18.28c-2.86 7.84-6.11 16.74-12.89 26.01c-4.28 5.85-11.66 10.64-19.09 12.77z",
    fill: "url(#IconifyId17ecdb2904d178eab8899)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.24 118.98C64 109 71 92 76.82 76.67c1.04-2.59 2.27-5.09 3.66-7.49c1.39-2.4 2.94-4.71 4.59-6.94c.86-1.15 1.84-2.23 2.91-3.22c1.09-.97 2.28-1.85 3.56-2.58c2.58-1.44 5.53-2.26 8.49-2.29c2.97-.02 5.9.75 8.49 2.12c2.57 1.39 4.91 3.38 6.36 6.04c.74 1.32 1.18 2.83 1.37 4.25c.21 1.44.23 2.9.09 4.33c-.32 2.86-1.28 5.63-2.9 7.99c-.81 1.17-1.82 2.22-2.87 3.11c-1.05.91-2.15 1.73-3.29 2.5c-2.28 1.52-4.68 2.92-7.29 3.71c1.26-.52 2.43-1.21 3.55-1.96c1.13-.74 2.22-1.55 3.26-2.4c2.05-1.72 4.16-3.49 5.4-5.75c1.29-2.24 1.98-4.81 2.08-7.36c.11-2.53-.31-5.18-1.54-7.2c-1.26-2.08-3.24-3.75-5.47-4.87s-4.74-1.68-7.21-1.63c-2.47.04-4.9.74-7.06 1.97c-1.07.63-2.07 1.38-3.01 2.22c-.91.87-1.77 1.8-2.55 2.81c-1.6 2.12-3.1 4.32-4.47 6.6c-.01.02-.03.05-.04.07c-1.94 3.24-3.49 6.71-4.75 10.27c-5.26 14.93-12.97 27.91-27.06 37.11c-.58.38-1.19.75-1.88.9z",
    fill: "#ffd54f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.98 68.72l-6.28-.11l-18.93-.33l-1.24-.03h-.18l-2.04-.04l-1.04-.01l-1.22-.02l-1.36-.03h-.49l-1.3-.03l-1.21-.02l-14.5-.26l-4.09-.07c1.22-6.53 4.09-9.41 7.27-11c2.73-1.37 5.69-1.79 8.01-2.75c.32-.12.62-.26.91-.42c.42-.22.81-.47 1.17-.76c.12-.1.24-.21.36-.33h.01c0-.01.01-.02.01-.02c1.04-1.02 1.7-2.49 1.77-4.77l11.74-.62c-.14 2.65.73 4.3 2.2 5.44c.07.06.14.11.21.16c.17.12.35.24.53.35c.45.26.93.5 1.45.72c.31.12.62.24.95.35c.27.1.55.19.84.27c.04.02.08.03.12.04c.15.05.3.09.45.14c.08.02.16.04.25.06c1.62.46 3.37.85 5.1 1.38c.25.08.52.17.81.27c.62.2 1.24.44 1.85.7c.21.1.4.18.57.26c.06.02.12.05.18.08c3.64 1.78 6.62 4.87 7.12 11.4z",
    fill: "#039be5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.87 87.3c-.51.74-1.12.97-1.66 1c-.63.03-1.16-.23-1.28-.3c-.01 0-.01-.01-.02-.01c0 0-11.78-7.36-9.64-19.79c.78-4.57 3.45-9.83 9.28-15.66c.07.06.14.11.21.16c.17.12.35.24.53.35c.45.26.93.5 1.45.72c-.28.34-.96 1.14-1.78 2.2c-3.15 3.99-5.66 8.04-6.43 12.28c-.31 1.69-.34 3.41-.02 5.18c1.03 5.62 4.83 9.49 7.06 11.91c.94.93 2.3 1.94 2.3 1.96z",
    opacity: 0.35,
    fill: "#212121"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8900",
    cx: 47.507,
    cy: 71.13,
    r: 14.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f37f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6d23"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7 68.61c-.12 1.38-.34 2.69-.7 3.81c-.12.39-.26.75-.42 1.09c-.67 1.43-1.63 2.87-2.6 4.26c-.17.24-.33.48-.5.72l-.32.46c-1.27 1.81-3.74 5.49-5.44 8.03l-1.25 1.86l-.25.37c-.25-.21-.59-.52-1.01-.91c-2.38-2.3-7.02-7.64-7.88-15.08v-.02c-.16-1.37-.18-2.74-.06-4.13c.02-.27.05-.54.08-.82c.57-5.01 2.89-10.11 6.94-15.2c.45.26.93.5 1.45.72c.31.12.62.24.95.35c.27.1.55.19.84.27c.04.02.08.03.12.04c.14.05.29.1.45.14c.08.02.16.04.25.06c1.62.46 3.37.85 5.1 1.38c.25.08.52.17.81.27c.75.25 1.36.5 1.85.7c.21.1.4.18.57.26c.06.02.12.05.17.07l.01.01c.44.86 1.27 6.46.84 11.29z",
    fill: "url(#IconifyId17ecdb2904d178eab8900)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.72 86.98l-1.25 1.86l-.25.37l-.3.44c-.42-.31-1.13-.87-1.99-1.65c-.01 0-.01-.01-.02-.01c-3.6-3.26-9.8-10.36-8.6-19.78c.6-4.67 3.01-9.89 8.45-15.51c.17.12.35.24.53.35c.45.26.93.5 1.45.72c.31.12.62.24.95.35c-.34.41-.87 1.06-1.49 1.85c-3.15 4-5.67 8.06-6.43 12.31c-.31 1.68-.34 3.39-.02 5.15c1.03 5.62 4.83 9.49 7.06 11.91c.63.62 1.44 1.27 1.91 1.64z",
    fill: "#fcb316"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.05 68.18c-.12 1.18-.39 2.47-.87 3.88c-1.88 5.47-5.07 14.59-21.52 14.79c.01-.09.03-.17.04-.25c.03-.17.06-.34.09-.5c.1-.53.19-1.02.29-1.49a2.73 2.73 0 0 1 1.89-.94c10.99-1.15 14.41-6.8 16.12-11.8c.45-1.31.7-2.56.81-3.75c.09-.87.1-1.71.05-2.49c-.08-1.53-.37-2.86-.69-3.93c-.06-.21-.14-.51-.24-.87c-.58-2.15-1.37-4.39-1.68-5.05c-.35-.74-.78-1.62-1.05-2.18c.42-.22.81-.47 1.17-.76c.12-.1.24-.21.36-.33h.01c.01.01.03.02.04.04c2.44 2.08 3.83 6.86 4.26 8.29c.37 1.24.79 2.7.94 4.44c.08.89.09 1.85-.02 2.9z",
    opacity: 0.35,
    fill: "#212121"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8901",
    cx: 19.205,
    cy: 69.53,
    r: 14.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#f78c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f37f21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6d23"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 68.15c-.02.28-.06.57-.1.86c-.16 1.13-.42 2.3-.84 3.51c-.3.89-.67 1.82-1.12 2.76c-2.33 4.86-7.01 10-18.35 10.82c-1.04.08-2.13.12-3.29.12c-.12-.01-.25-.01-.37-.01c.51-.65 1.13-1.58 1.78-2.7h.01a46.95 46.95 0 0 0 3.1-6.42c.72-1.86 1.3-3.78 1.57-5.53l.02-.14l.03-.16c.18-1.16.35-2.3.55-3.42c.51-2.99 1.16-5.89 2.35-8.79c.03-.08.09-.26.18-.51c.12-.35.4-1.19.65-1.77c2.73-1.37 5.69-1.79 8.01-2.75c.32-.12.62-.26.91-.42c.42-.22.81-.47 1.17-.76c1.42 2.13 2.34 5.54 2.78 7.18c.09.33.16.6.22.8a19.5 19.5 0 0 1 .74 7.33z",
    fill: "url(#IconifyId17ecdb2904d178eab8901)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.69 68.15c-.12 1.41-.42 2.93-.96 4.52c-1.76 5.16-5.72 12.93-20.03 13.93c-1.01.07-2.08.11-3.2.11c-.29 0-.57 0-.86-.01c.19-.21 1.62-2.03 2.27-3.19h.01c.55 0 1.44.11 2.85-.01c10.99-1.15 14.41-6.8 16.12-11.8c.43-1.25.68-2.46.8-3.6c.28-2.63-.13-4.92-.63-6.57c-.06-.21-.14-.51-.24-.87c-.58-2.15-1.37-4.39-1.68-5.05c-.24-.51-.52-1.09-.76-1.59c.32-.12.62-.26.91-.42c.42-.22.81-.47 1.17-.76c.12-.1.24-.21.36-.33h.01c0-.01.01-.02.01-.02l.03.06c1.74 2.59 2.7 6.91 3.06 8.11c.53 1.78 1.06 4.39.76 7.49z",
    fill: "#fcb316"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72.42c-.12.39-.26.75-.42 1.09c-.67 1.43-1.63 2.87-2.6 4.26c-5.95-.09-12.27-1.93-16-4.27l-.65-.28l-.99-.43c-1.64.55-4.2 1.55-7.2 2.49c-5.2 1.63-11.74 3.09-17.12 1.81c.72-1.86 1.3-3.78 1.57-5.53l.02-.14c2.37-1.75 12.59-2.45 13.01-2.45c.13 0 1.93.02 4.48.04a15486.863 15486.863 0 0 1 18.84.19L57 72.42z",
    opacity: 0.35,
    fill: "#212121"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.07 63.87c.38.45 2.66 2.58 2.64 4.76c-.02 1.79-.76 4.07-3.25 5.28c-6.59 3.22-18.85.65-24.47-2.9c-6.99-4.4-11.74-6.99-11.74-6.99C20.11 65.32 15 62.28 15 62.28s-6.67 1.28-7.78 1.25c-1.75-.04-2.18-2.4-.73-2.9c2.86-.99 9.7-5.02 12.36-4.87c1.45.08 16.13 2.9 20.35 4.1c1.36.39 9.53 1.85 9.53 1.85",
    fill: "#4fc3f7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.49 59.94s12.81-4.24 15.7-3.6c7.22 1.6 10.66 7.25 10.77 8.28c-.4 1.21-2.99 1.99-5.55 1.36c-3.42-.84-7.29-3.35-11.7-4.27c0 0-9.02-1.59-9.22-1.77z",
    fill: "#4fc3f7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.96 64.62c-.11.61-.65 1.09-1.19 1.4c-.55.32-1.16.51-1.78.64c-1.25.22-2.56.18-3.83-.28c-1.29-.43-2.3-1.33-3.2-2.05c-.89-.76-1.68-1.29-2.53-1.32l-.34-.01h-.46c-.31 0-.63.01-.93 0c-.62-.02-1.23-.05-1.84-.12c-1.21-.16-2.4-.33-3.57-.61c-2.34-.55-4.66-1.21-6.8-2.34c2.37.32 4.72.55 7.05.8c1.17.09 2.32.22 3.48.26c.57.02 1.15.06 1.71.05c.29.01.56-.01.84-.02l.43-.01h.56c.75.06 1.5.32 2.1.69c.61.37 1.11.79 1.55 1.2c.87.84 1.64 1.56 2.57 2.04c.91.46 2.03.72 3.13.74c.56.02 1.12-.04 1.66-.17c.51-.15 1.08-.37 1.39-.89z",
    fill: "#0277bd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.73 70.23c-1.46 1.08-15.26 6.36-24.71 4.24c-2.19-.49-5.15-1.1-5.84-3.69c-.84-3.18 2.91-7.44 2.91-7.44l5.9-1.04l3.51 1.32c1.06.4 2.18.58 3.31.55l4.43-.14c0-.01 11.01 6.2 10.49 6.2z",
    fill: "#4fc3f7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 40.67c-1.06-.23-2.92-.81-4.21-2.16c-2.36-2.49-3.08-7.49-3.26-9.31c1.31.12 4.28.58 5.81 2.39l1.66 9.08z",
    fill: "#039be5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.04 38.42c-.14 1.64-.96 3.01-2.2 3.03c-1.24.03-2.27-1.3-2.3-2.95c-.02-1.25.53-2.33 1.34-2.79l.47.97c-.41.28-.76.95-.74 1.81c.02 1.14.65 1.92 1.21 1.91c.56-.01 1.16-.81 1.15-1.95c-.01-.94-.14-1.23-.38-1.75c-.39-.88.26-1.56.88-.7c0 0 .7.84.57 2.42z",
    fill: "#fcb316"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.28 31.59c1.53-1.82 4.5-2.27 5.81-2.39c-.18 1.82-.9 6.82-3.26 9.31c-1.29 1.36-3.15 1.94-4.21 2.16l1.66-9.08z",
    fill: "#039be5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.68 52.13l1.22.08h1.62c9.01-.6 15.04-8.94 15.23-22.14c.19-13.13-7.9-19.75-16.23-19.87S18.9 16.45 18.71 29.58c-.2 13.22 6.42 21.86 14.97 22.55z",
    fill: "#4fc3f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01579b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.76 29.8c-.31.28-.79.09-1.23-.08c-.98-.37-1.44-.66-2.53-.87c-.91-.17-2.05-.22-2.94.05c-.81.24-.72-.05-.17-.52c1.15-.98 2.14-1.15 3.63-1.09c2.19.1 4.28 1.57 3.24 2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7 29.8c.31.28.79.09 1.23-.08c.98-.37 1.44-.66 2.53-.87c.91-.17 2.05-.22 2.94.05c.81.24.72-.05.17-.52c-1.15-.98-2.14-1.15-3.63-1.09c-2.18.1-4.27 1.57-3.24 2.51z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.11 38.19c-.05-.02-.1-.03-.15-.04l-3.42-.05c-.05.01-.1.02-.16.04c-.31.12-.49.44-.35.78s.81 1.31 2.18 1.33s2.07-.93 2.22-1.27s-.02-.66-.32-.79z",
    fill: "#0277bd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.31 42.13c-1.55.89-6.6.82-8.12-.12c-.88-.54-1.79.25-1.44 1.06c.35.79 3.08 2.67 5.46 2.7s5.13-1.76 5.5-2.54c.37-.8-.51-1.61-1.4-1.1z",
    fill: "#4e342e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M52.95 36c.62-.86 1.27-.18.88.7c-.24.52-.37.81-.38 1.75c-.01 1.14.59 1.94 1.15 1.95s1.19-.77 1.21-1.91c.02-.86-.33-1.53-.74-1.81l.47-.97c.81.46 1.36 1.54 1.34 2.79c-.03 1.65-1.06 2.98-2.3 2.95c-1.24-.02-2.06-1.39-2.2-3.03c-.13-1.58.57-2.42.57-2.42z",
    fill: "#fcb316"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.29,
    cy: 33.6,
    r: 2.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.17,
    cy: 33.6,
    r: 2.38
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab8902",
    gradientUnits: "userSpaceOnUse",
    x1: 106.093,
    y1: 16.959,
    x2: 102.103,
    y2: 5.219,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed6d23"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.24 113.57c-5.58-.89-5.1-2.6-5.63-4.19l-5.33-1.56c-1.22 1.05-2.38 3.23-6.97.99c-1.41-.69-6.17-4.72-6.17-4.72l-3.59-.91c.46.42 4.37 5.45 7.7 9.66c4.16 5.27 6.65 6.25 8.48 6.78c2.74.8 5.92.4 5.92.4s5.34.58 9-.76c3.8-1.39 5.53-4.9 5.53-4.9s-6.42-.55-8.94-.79zm2.81 4.06c-1.38.5-3.06.7-4.54.76a9.639 9.639 0 0 0 2.66-2.98c1.02.09 2.51.23 4.71.42c-.72.69-1.66 1.38-2.83 1.8z",
    fill: "url(#IconifyId17ecdb2904d178eab8902)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8903",
    cx: 109.97,
    cy: 15.13,
    r: 8.699,
    gradientTransform: "matrix(.9726 -.2326 -.2175 -.9094 5.95 153.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#febc12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fea709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#ff9000"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M121.88 115.84c-.72.69-1.66 1.37-2.83 1.8c-1.38.5-3.06.7-4.54.76c1.08-.79 2.13-2.16 2.66-2.98c-3 .16-6.87-.14-10.79-1.29c-7.36-2.16-13.58-8.93-14.64-10.14l-3.19-.81c.46.42 4.37 5.45 7.7 9.66c2.81 3.55 4.85 5.15 6.45 5.98c-3.41-.11-5.44 1.97-5.44 1.97l13.17 3.86s-.59-2.87-3.56-4.62c2.03.22 3.78 0 3.78 0s5.34.58 9-.76c3.8-1.39 5.53-4.9 5.53-4.9l-3.3 1.47z",
    fill: "url(#IconifyId17ecdb2904d178eab8903)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8904",
    cx: 106.87,
    cy: 27.3,
    r: 3.775,
    gradientTransform: "scale(1 -1) rotate(-16.333 -341.236 -48.333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febc12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f00"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.34 104.94l-3.27 3.12l5.65 1.66l-1.5-4.48l1.16-.95c.33-.27.5-.68.46-1.1l-.21-2.42a.547.547 0 0 0-.96-.31l-1.61 1.85c-.31.35-.4.85-.23 1.29l.51 1.34z",
    fill: "url(#IconifyId17ecdb2904d178eab8904)"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8905",
    cx: 106.823,
    cy: 6.94,
    r: 4.386,
    gradientTransform: "scale(1 -1) rotate(-16.333 -341.236 -48.333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef59f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#fac537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9bf2c"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#IconifyId17ecdb2904d178eab8905)",
    d: "M110.04 123.59l-11.85-3.48l1.48-.78l9.51 2.79z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M46.04 22.63c-3.84 0-7.52-1.38-10.94-4.11c-3.87-3.09-6.95-3.74-8.84-3.74c-1.03 0-1.86.18-2.49.4c.38-3.46 2.4-6.75 5.31-8.54c2.31-1.43 4.89-2.15 7.68-2.15c2.19 0 4.02.47 4.92.87c3.22 1.44 5.28 2 7.34 2c1.34 0 2.72-.25 4.37-.79c-.36 1.47-1.36 2.8-2.7 3.5l-1.08.57l1.18.36c.61.18 1.27.27 1.95.27c4.05 0 8.14-3.21 9.79-4.68c.18 3.19-.29 13.06-12.46 15.57c-.79.17-2.26.47-4.03.47z",
    fill: "#0f3b7c"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8906",
    cx: 48.614,
    cy: 7.848,
    r: 25.905,
    gradientTransform: "matrix(.9023 -.4311 -.3198 -.6695 -1.605 35.214)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#00838f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00838f"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.53 6.59c-.07 1.06 1.16 12.6-12.42 15.54c-8.95 1.94-13.99-2.8-14.17-2.97c0 0 5.39.1 5.81-1.08c.54-1.52-.23-2.83-.23-2.83c11.27.18 17.03-5.4 21.01-8.66z",
    fill: "url(#IconifyId17ecdb2904d178eab8906)"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8907",
    cx: 18.163,
    cy: -14.422,
    r: 20.455,
    gradientTransform: "matrix(-.9674 .2534 .188 .7177 61.917 22.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#00838f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00838f"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M23.77 15.18c.21-.8.68-8.61 10.38-10.47c.64-.12 1.43-.17 2.15-.23c2.21-.16 4.38.48 5.78 1.05c1.57.64 2.57 1.07 4.21 1.49c2.48.64-.49 3.37-3.29 3.68c-1.29.14-2.53.23-3.21.16c-.56-.06-6.38 6.05-9.55 4.74c-2.98-1.22-5.81-.78-6.47-.42z",
    fill: "url(#IconifyId17ecdb2904d178eab8907)"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab8908",
    cx: -21.355,
    cy: -68.186,
    r: 13.689,
    gradientTransform: "matrix(.9811 .1935 .1435 -.7279 72.308 -42.138)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#00838f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00838f"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.39 6.57c-.37 1.54-1.23 2.95-3.78 4.07c-1.51.66-4.28.94-5.35.61c-5.96-1.82-2-5.45.96-4.52c2.99.94 5 .83 8.17-.16z",
    fill: "url(#IconifyId17ecdb2904d178eab8908)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.45 73.91c-2.87 1.63-6.32 2.06-9.61 2c-3.32-.07-6.62-.63-9.81-1.62c-1.59-.51-3.17-1.11-4.67-1.93c-.77-.42-1.45-.85-2.14-1.28l-2.08-1.26c-2.75-1.71-5.56-3.37-8.34-5l.62.09c-1.01.17-2.03.3-3.05.28c-1.02-.01-2.03-.12-3.02-.31c-.99-.19-1.97-.45-2.9-.82c-.94-.36-1.83-.77-2.72-1.32l.36.06c-1.31.18-2.61.34-3.93.49l-1.97.19c-.66.04-1.32.1-1.98.06c.65-.07 1.29-.24 1.93-.38l1.92-.45l3.83-.92l.16-.04l.21.1c.8.4 1.71.73 2.6.98c.9.25 1.81.45 2.73.56c.92.12 1.84.16 2.76.11c.92-.01 1.82-.17 2.71-.35l.32-.06l.3.15c2.92 1.52 5.72 3.19 8.52 4.87l2.08 1.3c.69.44 1.38.88 2.04 1.25c1.36.74 2.81 1.38 4.3 1.92c1.5.52 3.03.96 4.59 1.33c1.56.34 3.14.63 4.73.8c3.15.31 6.42.31 9.51-.8z",
    fill: "#0277bd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenieSvgrepoCom);
export default __webpack_public_path__ + "static/media/genie-svgrepo-com.348272e28223d93a84a5de4b29c1292d.svg";
export { ForwardRef as ReactComponent };